//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div class="go_device-calibration-v2">
    <div
      class="go_device-calibration-v2-checkerboard"
      :style="{
        gridTemplateColumns: `repeat(${config.columns}, ${config.square_size_px}px)`,
        gridTemplateRows: `repeat(${config.rows}, ${config.square_size_px}px)`,
      }"
    >
      <div
        v-for="n in config.columns * config.rows"
        :key="n"
        :class="['go_square', getRowType(n) ? 'go_odd' : 'go_even']"
      ></div>
      <svg
        v-for="(circle, index) in config.colors_data"
        :key="index"
        class="go_circle"
        :style="{
          fill: circle.color,
          width: `${config.square_size_px}px`,
          height: `${config.square_size_px}px`,
          top: getCircleY(circle.y),
          left: getCircleX(circle.x),
        }"
      >
        <circle
          :cx="`${config.circle_position}px`"
          :cy="`${config.circle_position}px`"
          :r="`${config.circle_radius}px`"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();

const config = computed(function () {
  return store.state.page.matrixConfiguration;
});

function getRowType(n) {
  let isOdd = false;
  isOdd = Math.ceil(n / 16) % 2;
  return isOdd;
}

function getCircleX(columnNo) {
  return `${columnNo * config.value.square_size_px}px`;
}

function getCircleY(rowNo) {
  return `${rowNo * config.value.square_size_px}px`;
}
</script>

<style lang="scss" scoped>
.go_device-calibration-v2 {
  height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  .go_device-calibration-v2-checkerboard {
    display: grid;
    grid-gap: 0px;
    position: relative;

    .go_square {
      &.go_odd:nth-child(odd) {
        background: #000;
      }

      &.go_even:nth-child(even) {
        background: #000;
      }
    }

    .go_circle {
      position: absolute;
      fill: red;
      top: 76px;
    }
  }
}
</style>
